var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
/** <b>Composant d'affichage en mode list d'un champ de type email</b>*/
export default function EmailFieldList(_a) {
    var record = _a.record, fieldName = _a.fieldName;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName] || "";
    }, [record]);
    return (_jsx("div", { children: _jsx("a", __assign({ href: "mailto:".concat(value), onClick: function (e) {
                window.location.href = "mailto:".concat(value);
                e.preventDefault();
            }, className: "" }, { children: _jsx("div", { children: _jsx("span", __assign({ className: "text-[rgb(var(--color-blue-800))] hover:text-blue-600" }, { children: value })) }) })) }));
}
